import dayjs from 'dayjs';
import style from './index.module.scss';

const durationToTime = (duration) => {
  if (!Number.isFinite(duration) || duration < 0) return null;

  const time = dayjs.utc(duration * 1000);
  const hours = time.hour();

  if (hours === 0) {
    return time.format('mm:ss');
  }

  return time.format('HH:mm:ss');
};

export default function VideoThumbnail({ thumbnail, alt = '', duration = 0, className = '' }) {
  return (
    <figure className={`${style.figure} ${className}`}>
      <img
        src={thumbnail}
        alt={alt}
        className={style.figure__image}
        onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
      />
      <div className={style.duration}>
        <span>{durationToTime(duration)}</span>
      </div>
    </figure>
  );
}
